import { render, staticRenderFns } from "./SupplierItem.vue?vue&type=template&id=7bda8363&scoped=true"
import script from "./SupplierItem.vue?vue&type=script&lang=js"
export * from "./SupplierItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda8363",
  null
  
)

export default component.exports